import {
  GET_MARKET_LIST,
  GET_MARKET_LIST_SUCCESS,
  GET_MARKET_LIST_FAILED,
} from './actionTypes';

export const actionGetMarketList = (payload) => ({
  payload,
  type: GET_MARKET_LIST,
});

export const actionGetMarketListSuccess = (payload) => ({
  payload,
  type: GET_MARKET_LIST_SUCCESS,
});

export const actionGetMarketListFailed = (payload) => ({
  payload,
  type: GET_MARKET_LIST_FAILED,
});
